import { reportArriendoRepository } from "../repositories/ReportArriendos.repository";

export const reportArriendosService = {
   getGrouped: (data) => {
      return reportArriendoRepository.getGrouped(data);
   },
   getDetail: (data) => {
      return reportArriendoRepository.getDetail(data);
   },

};
